import { useQuery } from "react-query";
import { getAllPlacements } from "services/placement.service";

export default function usePlacements(params?: {
  page?: number;
  limit?: number;
  status?: string;
}) {
  return useQuery(["placements", params], () => getAllPlacements(params), {
    keepPreviousData: true,
  });
}
